import { Zoom } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import React from 'react';
import { MdClose } from 'react-icons/md';
import { isSuperAdminLogin } from '../../utils';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Zoom ref={ref} {...props} />;
});

export default function CustomShowModal(props) {
    const {
        open,
        handleClose,
        maxWidth = "none",
        title = 'Stores',
        disableClose = false,
        paperStyle = {},
        paperClassName = "",
    } = props;

    const isAutoWidth = maxWidth === "none" || maxWidth === false;

    return (
        <Dialog
            open={open}
            onClose={disableClose ? () => { } : handleClose}
            scroll="paper"
            TransitionComponent={Transition}
            TransitionProps={props.TransitionProps}
            fullWidth={!isAutoWidth}
            maxWidth={isAutoWidth ? false : maxWidth}
            classes={{
                paper: `rounded-none overflow-hidden border border-slate-200 shadow-2xl transition-all duration-300 ${isSuperAdminLogin() ? "superadmin-dialog" : ""} ${paperClassName}`,
            }}
            PaperProps={{
                style: isAutoWidth
                    ? {
                        width: 'max-content',
                        maxWidth: '96vw',
                        ...paperStyle,
                        ...props.PaperProps?.style,
                    }
                    : {
                        ...paperStyle,
                        ...props.PaperProps?.style,
                    }
            }}
        >
            <div className="flex items-center justify-between w-full px-3.5 py-1.5 bg-[#f8fafc] border-b border-slate-200">
                <div
                    id="customized-dialog-title"
                    className="text-[#313C4C] text-[14px] font-medium tracking-wide"
                >
                    {title}
                </div>
                <button
                    onClick={handleClose}
                    className="p-1 rounded-full text-slate-500 hover:text-slate-800 hover:bg-slate-200/80 transition-colors border-none bg-transparent cursor-pointer flex items-center justify-center"
                    title="Close"
                >
                    <MdClose size={16} />
                </button>
            </div>

            <DialogContent dividers className={`scroll-thin bg-white ${props.contentClassName || "!p-1.5 sm:!p-1.5"}`}>
                {props.children}
            </DialogContent>
        </Dialog>
    );
}
